<template>
  <v-container fluid>
    <v-card flat>
      <v-card-text>
        The Sasa<span class="red--text">Pay</span> REST API allows you to process payouts and payment collections.<br/>
      </v-card-text>
      <v-divider/>
      <v-card-text>
        Try out our REST APIs with test credentials on Postman
      </v-card-text>
      <v-card-text>
        <v-btn
            class="mx-2"
                dark
                small
                color="error"
            @click="postman"
        >
          <v-icon>mdi-animation-play</v-icon> Run in Postman</v-btn>
      </v-card-text>
      <v-divider/>
      <v-card-text>
        The API uses standard verbs and returns HTTP response codes and JSON-encoded responses.

      </v-card-text>
      <v-card-text>
        To get started with the Sasa<span class="red--text">Pay</span> REST API, first create a developer account on the Developer Dashboard. From there you can generate your credentials, authentication token and sandbox accounts.
      </v-card-text>
      <v-card-text>

        Logging into the Developer Dashboard to get credentials and create sandbox accounts requires a developer, personal, or business account. Each account provides different levels of access to Sasa<span class="red--text">Pay</span> functionality. If you need to access a capability you don't currently have, you can upgrade your account on the My Account page in the Developer Dashboard.

      </v-card-text>
      <v-card-text>
        <v-divider/>
        <div class="ma-4">
          <h1 class="text-center">Our Sample B2C</h1>
        </div>
        <v-row>
          <v-col cols="12" md="6">
            <h3>Sample Request</h3>
            <code-editor
                :read_only="true"
                theme="dark"
                v-model="code"
                @lang="changeLanguage"
                :wrap_code="false"
                :language_selector="true"
                class="github_dark"
                :copy_code="true"
                font_size="14px"
                width="100%"
                :languages="[['php','PHP'],['java','Java'],['python', 'Python'],['go','Go'],['csharp','C#'],['javascript', 'Node Js']]"
            ></code-editor>
            <v-divider/>

            <v-divider/>
          </v-col>
          <v-col cols="12" md="6">
            <h3>Sample Response</h3>
            <code-editor
                :read_only="true"
                theme="dark"
                v-model="response"
                :wrap_code="false"
                :language_selector="true"
                class="github_dark"
                :copy_code="true"
                font_size="14px"
                width="100%"
                :languages="[['json','JSON']]"
            ></code-editor>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <ScrollDownIcon/>
  </v-container>
</template>

<script>
import ScrollDownIcon from "../../../../../shared/scroller/ScrollDownIcon.vue";
import {getB2BRequest, getB2BResponse, getB2CRequest, getB2CResponse} from "../../../../../shared/snippets/b2c/b2c";

export default {
  name: "Introduction",
  components: {ScrollDownIcon},
  // components: { VueStylelintEditor },
  data: () =>({
    selectedLanguage:"",
    b2bCode:"",
    code:"",
    response:"",
    b2bResponse:"",
  }),
  mounted() {
    this.importSnippets('php')//
    this.importResponse()
    //
    this.importB2BSnippets('php')
    this.importB2BResponse()
  },
  methods:{
    postman(){
      window.open("https://documenter.getpostman.com/view/25692691/2s935oN4jW","_blank")
    },
    importSnippets(lang){
      this.code=getB2CRequest(lang)
    },
    importResponse(){
      this.response=getB2CResponse()
    },
    changeLanguage(val) {
      this.importSnippets(val)
    },
    //b2b
    importB2BSnippets(lang){
      this.b2bCode=getB2BRequest(lang)
    },
    importB2BResponse(){
      this.b2bResponse=getB2BResponse()
    },
    changeB2BLanguage(val) {
      this.importB2BSnippets(val)
    }
  }
}
</script>

<style scoped>

</style>
